/** Helpers de formato propios de la mini-app (no se tocan los de otras pantallas). */

export const SITE_FLAGS: Record<string, string> = {
  MLA: '🇦🇷',
  MLM: '🇲🇽',
  MLC: '🇨🇱',
  MCO: '🇨🇴',
  MLU: '🇺🇾',
  MLB: '🇧🇷',
};

/** Quita etiquetas HTML y decodifica entidades para mostrar texto plano. */
export function stripHtml(html: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent?.trim() || '';
}

export function fmtMoney(n: number | null | undefined, cur = 'USD'): string {
  if (n == null || Number.isNaN(Number(n))) return '—';
  try {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: cur }).format(Number(n));
  } catch {
    return `${cur} ${Number(n).toFixed(2)}`;
  }
}

export function fmtDate(s: string | null | undefined): string {
  if (!s) return '—';
  const d = new Date(s);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
}

/** "en 3 días" / "hace 2 h" relativo a ahora, para el reloj de vencimiento. */
export function fmtDueIn(s: string | null | undefined): string {
  if (!s) return '';
  const d = new Date(s).getTime();
  if (Number.isNaN(d)) return '';
  const diff = d - Date.now();
  const abs = Math.abs(diff);
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const label = days > 0 ? `${days} día${days > 1 ? 's' : ''}` : `${hours} h`;
  return diff >= 0 ? `vence en ${label}` : `vencido hace ${label}`;
}
